<h1 mat-dialog-title>Salida fuera de tu horario configurado</h1>
<mat-dialog-content>
  <p>
    Tu horario de hoy termina a las <b>{{ data.scheduled_exit_time }}</b> y estás intentando fichar salida a las
    <b>{{ data.current_time }}</b
    >, una hora que no tienes configurada.
  </p>

  <p class="warning-text">
    Si fichas salida sin ajustar tu horario, este tiempo extra no quedará reflejado en tu jornada prevista y
    <b>afectará negativamente a tu KPI</b>.
  </p>

  <p class="info-title">¿Qué puedes hacer?</p>
  <ul class="info-list">
    <li>
      Si estás dentro del <b>periodo de gracia</b>, puedes alargar la hora de salida de la última franja del día en la excepción horaria de
      esta semana.
    </li>
    <li>
      Si el periodo de gracia ya ha pasado, puedes <b>crear una franja nueva el mismo día</b> para representar el tiempo que te has
      excedido.
    </li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="accent" (click)="manageException()">
    <mat-icon>edit_calendar</mat-icon>
    Gestionar excepción horaria
  </button>
  <button mat-flat-button color="warn" (click)="confirmClockOut()">Fichar salida igualmente</button>
</mat-dialog-actions>
